import React from 'react';
import toyotaLogo from '../../assets/images/toyota.svg';
import './Logo.css';

const logo = () => (
  <div className="toyotaLogo">
    <img alt="OSB Manage" src={toyotaLogo} />
  </div>
);

export default logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js